const cityConfig = {
    toronto: {
        locationId: 13929,
        locationName: 'Toronto',
        badgeGroup: 'ontario',
        cities: ['Toronto', 'Mississauga', 'Brampton', 'Markham', 'Vaughan', 'Richmond Hill', 'Oakville', 'Burlington', 'Milton', 'Caledon'],
    },

    'gta': {
        locationId: 13516,
        locationName: 'GTA East & North',
        badgeGroup: 'ontario',
        cities: [
            'Pickering',
            'Ajax',
            'Whitby',
            'Oshawa',
            'Bowmanville',
            'Uxbridge',
            'Markham',
            'Richmond Hill',
            'Newmarket',
            'Scarborough',
            'East York',
            'North York',
            'Markham',
    ]
    },

    'atlanta-north': {
        locationId: 10294,
        locationName: 'Atlanta North',
        badgeGroup: 'georgia',
        cities: ['Atlanta', 'Marietta', 'Sandy Springs', 'Roswell', 'Alpharetta', 'Dunwoody', 'Decatur', 'East Point', 'Smyrna', 'Stone Mountain']
    },

    'atlanta': {
        locationId: 10294,
        locationName: 'Atlanta',
        badgeGroup: 'georgia',
        cities: ['Atlanta', 'Marietta', 'Sandy Springs', 'Roswell', 'Alpharetta', 'Dunwoody', 'Decatur', 'East Point', 'Smyrna', 'Stone Mountain']
    },

    'charlotte-junk-removal': {
        locationId: 18135,
        locationName: 'Charlotte',
        badgeGroup: 'north-carolina',
        cities: ['Charlotte', 'Matthews', 'Pineville', 'Gastonia', 'Rock Hill', 'Indian Trail', 'Waxhaws', 'Monroe', 'Tega Cay', 'Fort Mill']
    },

    'nashville-junk-removal': {
        locationId: 18135,
        locationName: 'Nashville',
        badgeGroup: 'tennessee',
        cities: ['Nashville', 'Murfreesboro', 'Franklin', 'Gallatin', 'Lebanon', 'Spring Hill', 'Hendersonville', 'Madison', 'Dickson', 'La Vergne']
    },

    miami: {
        locationId: 18689,
        locationName: 'Miami',
        badgeGroup: 'florida',
        cities: ['Miami', 'Hollywood', 'Pompano Beach', 'Coral Gables', 'Miami Beach', 'Kendall', 'Hialeah', 'Pembroke Pines', 'Miami Gardens', 'Aventura']
    },

    'fort-lauderdale': {
        locationId: 18689,
        locationName: 'Ft Lauderdale',
        badgeGroup: 'florida',
        cities: ['Miami', 'Hollywood', 'Pompano Beach', 'Coral Gables', 'Miami Beach', 'Kendall', 'Hialeah', 'Pembroke Pines', 'Miami Gardens', 'Aventura']
    },
    
    kitchener: {
        locationId: 15585,
        locationName: 'Kitchener-Waterloo',
        badgeGroup: 'ontario',
        cities: ['Kitchener', 'Waterloo', 'Cambridge', 'Guelph', 'Brantford'],
    },

    waterloo: {
        locationId: 15585,
        locationName: 'Kitchener-Waterloo',
        badgeGroup: 'ontario',
        cities: ['Kitchener', 'Waterloo', 'Cambridge', 'Guelph', 'Brantford'],
    },

    cambridge: {
        locationId: 15585,
        locationName: 'Cambridge',
        badgeGroup: 'ontario',
        cities: ['Kitchener', 'Waterloo', 'Cambridge', 'Guelph', 'Brantford'],
    },

    guelph: {
        locationId: 15585,
        locationName: 'Guelph',
        badgeGroup: 'ontario',
        cities: ['Kitchener', 'Waterloo', 'Cambridge', 'Guelph', 'Brantford'],
    },

    brantford: {
        locationId: 15585,
        locationName: 'Brantford',
        badgeGroup: 'ontario',
        cities: ['Kitchener', 'Waterloo', 'Cambridge', 'Guelph', 'Brantford'],
    },

    edmonton: {
        locationId: 13337,
        locationName: 'Edmonton',
        badgeGroup: 'alberta',
        cities: ['Edmonton', 'Sherwood Park', 'St. Albert', 'Spruce Grove', 'Leduc', 'Fort Saskatchewan'],
    },

    ottawa: {
        locationId: 15304,
        locationName: 'Ottawa',
        badgeGroup: 'quebec',
        cities: ['Ottawa', 'Gatineau'],
    },

    hamilton: {
        locationId: 35818,
        locationName: 'Hamilton',
        badgeGroup: 'ontario',
        cities: ['Hamilton', 'Burlington', 'Oakville', 'Milton', 'Halton Hills'],
    },

    'orlando-north': {
        locationId: 15697,
        locationName: 'Orlando North',
        badgeGroup: 'florida',
        cities: ['Orlando', 'Winter Garden', 'Windermere', 'Clermont', 'Ocoee', 'Kissimmee', 'Winter Park', 'Altamonte Springs', 'Maitland', 'Oviedo'],
    },

    niagara: {
        locationId: 35818,
        locationName: 'Niagara',
        badgeGroup: 'ontario',
        cities: ['St. Catharines', 'Niagara Falls', 'Welland', 'Fort Erie', 'Grimsby', 'Lincoln', 'Niagara-on-the-Lake', 'Pelham', 'Port Colborne', 'Thorold', 'Wainfleet', 'West Lincoln'],
    },
    
    houston: {
        locationId: 35818,
        locationName: 'Houston',
        badgeGroup: 'texas',
    },

    'east-houston': {
        locationId: 35818,
        locationName: 'East Houston',
        badgeGroup: 'texas',
    },

    sanantonio: {
        locationId: 19493,
        locationName: 'San Antonio',
        badgeGroup: 'texas',
        cities: ['San Antonio', 'New Braunfels', 'Seguin', 'Boerne', 'Schertz', 'Cibolo', 'Converse', 'Universal City', 'Live Oak', 'Selma'],
    },

    barrie: {
        locationId: 16243,
        locationName: 'Barrie',
        badgeGroup: 'ontario',
        cities: ['Barrie', 'Orillia', 'Midland', 'Collingwood', 'Wasaga Beach'],
    },
};

export default cityConfig;